//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        service: {
            type: Object,
            default() {
                return {}
            }
        },
        active: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        isShowImg() {
            return process.env.isShowImgAppointment === 'true';
        },

        // Стоимость услуги
        servicePrice() {
            if (!this.service.price || this.service.price === 0) {
                return 'бесплатно'
            }

            return `${this.service.price} ₽`
        },
        servicePriceOld() {
            if (
              !this.service.price_old ||
              this.service.price_old <= this.service.price
            ) {
                return
            }

            return `${this.service.price_old} ₽`
        },

        // Длительность услуги
        serviceDuration() {
            const duration = this.service.duration

            const hours = Math.floor(duration / 60)
            const minuts = duration - hours * 60

            return [
                hours
                  ? `${hours} ${this.$caseWords(hours, ['час', 'часа', 'часов'])}`
                  : undefined,
                minuts
                  ? `${minuts} ${this.$caseWords(minuts, [
                      'минута',
                      'минуты',
                      'минут'
                  ])}`
                  : undefined
            ].join(' ')
        },

        // Возраст детей
        serviceTags() {
            let tags = [];

            // Возраст детей
            // if (this.service.for_children_2_6 && !this.service.for_children_7_11 && !this.service.for_children_12_18) {
            //   tags.push("Для детей от 2 до 6 лет")
            // }
            // if (!this.service.for_children_2_6 && this.service.for_children_7_11 && !this.service.for_children_12_18) {
            //   tags.push("Для детей от 7 до 11 лет")
            // }
            // if (!this.service.for_children_2_6 && !this.service.for_children_7_11 && this.service.for_children_12_18) {
            //   tags.push("Для детей от 12 до 18 лет")
            // }
            //
            // if (this.service.for_children_2_6 && this.service.for_children_7_11 && !this.service.for_children_12_18) {
            //   tags.push("Для детей от 2 до 11 лет")
            // }
            // if (!this.service.for_children_2_6 && this.service.for_children_7_11 && this.service.for_children_12_18) {
            //   tags.push("Для детей от 7 до 18 лет")
            // }
            // if (this.service.for_children_2_6 && this.service.for_children_7_11&& this.service.for_children_12_18) {
            //   tags.push("Для детей от 2 до 18 лет")
            // }

            // Есть обучение
            // if (this.service?.with_learning) {
            //     tags.push("Возможно обучение");
            // }

            return tags
        },

        servicePrepare() {
          return this.service?.service_prepare || ''
        }

    }
}
